import React, { useState, useEffect, } from 'react'
import { DataGrid } from '@mui/x-data-grid'
import PropTypes from 'prop-types';
import Delete from '@mui/icons-material/Delete';
import axios from 'src/utils/axios';
import { useNavigate } from 'react-router-dom';
import Tooltip from '@mui/material/Tooltip';
import {
  Box,
  IconButton,
  SvgIcon,
} from '@mui/material';
import {
  Eye as ViewIcon,
  Edit as EditIcon,
  ArrowRight as ArrowRightIcon,
  Search as SearchIcon
} from 'react-feather';
// import NewsEdit from '../NewsEditView';
import { fetchNews } from 'src/actions/mgmtNewsAction';
import { useDispatch } from 'react-redux';

function Results({ className, issuesList, businessInfo, ...rest }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {

  }, [issuesList]);


  // const handleDelete = async (customerId, newsId) => {
  //   // console.log("ServiceID", serviceId);
  //   try {
  //     const payload =
  //     {

  //       "customerId": customerId,
  //       "newsId": newsId

  //     }
  //     const deleteResult = await axios.post(`/api/admin/customer/info/delete/news`, payload);
  //     console.log(`deleteResult: `, deleteResult);
  //     // dispatch(fetchNews(customerId));
  //   } catch (err) { }
  // };

  const columns = [
    // { field: 'customerId', headerName: 'customerId', width: 100 },
    { field: 'issueId', headerName: 'Issue Id', width: 200 },
    {
      field: "action",
      headerName: "Action",
      width: 100,
      renderCell: (params) => {
        return (
          <div className="cellAction">
            <Tooltip title="View Details">
              <IconButton
                onClick={() => {
                  navigate('/app/management/issue', { state: {data : params.row } });
                }
                }
              >
                <SvgIcon fontSize="small">
                  <ViewIcon />
                </SvgIcon>
              </IconButton>
            </Tooltip>
            {/* <m>
              <Tooltip title="Delete News">
                <IconButton
                  onClick={() => handleDelete(params.row.customerId, params.row.newsId)}
                >
                  <SvgIcon fontSize="small">
                    <Delete />
                  </SvgIcon>
                </IconButton>
              </Tooltip></m> */}
          </div>
        );
      },
    },
    { field: 'ondcOrderId', headerName: 'ONDC Order Id', width: 200 },
    { field: 'status', headerName: 'Status', width: 200 },
    { field: 'resolutionTime', headerName: 'Resolution Time', width: 200, valueGetter: (params) => params.row.resolutionTime?.duration || '-', },
    { field: 'responseTime', headerName: 'Response Time', width: 200, valueGetter: (params) => params.row.responseTime?.duration || '-', },
  ];

  return (
    <Box sx={{ height: "600px", width: '100%', padding: 2 }}>
      <DataGrid
        rows={issuesList}
        columns={columns}
        getRowId={(row) => row.issueId}
        // checkboxSelection={true}
        pageSize={10}
        rowsPerPageOptions={[10]}
      />
    </Box>
  )
}

Results.propTypes = {
  className: PropTypes.string,
  newsList: PropTypes.array
};

Results.defaultProps = {
  issuesList: []
};

export default Results;